/**
 * defa.views.InvoiceCollectionView
 * A snippet view for a single invoice.
 * @version 1.2.0
 */
import EmptyView      from 'scripts/defa/basic/view-empty-view';
import InvoiceSnippet from 'scripts/defa/invoices/view-invoice-snippet';
import CollectionView from 'scripts/poppet/collection-view';

const InvoiceCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: InvoiceSnippet,
	emptyView: EmptyView,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a childView requests to open an invoice.
	 * @param {view} childView  The view the event originated from.
	 * @void
	 */
	onChildviewOpen: function ( childView ) {
		this.trigger( 'nav', 'invoice:update', [ childView.model.get( 'id' ), ] );
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default InvoiceCollectionView;